import Vue from 'vue'
import Antd from 'ant-design-vue';
import Vant from 'vant';
import 'lib-flexible'
import App from './App.vue'
import 'ant-design-vue/dist/antd.css';
import 'vant/lib/index.css';
import router from './router'
import store from './store'
import axios from "axios";

Vue.config.productionTip = false

Vue.use(Antd);
Vue.use(Vant);
Vue.prototype.$axios = axios;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
